<carm-main-header-lang-section-view
  [isLoggedIn]="isLoggedIn$ | async"
  (logout) = "onLogout()"
></carm-main-header-lang-section-view
  >
